
























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { ParticaEvent, getActionName, eParticaAction } from "../Models/ParticaEvent";
import ParticaAccountBase from "./Base/ParticaAccountBase.vue";
import { OwnerPaymentDTO, OwnerPaymentArticleDTO, TailoringPaymentDTO, TailoringPaymentIssueDTO, UserLoginDetails } from "../Generated/ParticaAPI";
import { IContentStreamPaymentService } from "../BusinessServices/contentstreampayment";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
//import AccountStreamOwnerPayments from "../Ui-Components/Account/AccountStreamOwnerPayments.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import { ArrayUtils } from "../BusinessServices/arrayutils";
//import AccountStreamTailoringPayments from "@/Ui-Components/Account/AccountStreamTailoringPayments.vue";
import { ParticaListContent, ParticaListLineContent } from "../Models/ParticaListModel";
import { IUserService } from "../BusinessServices/user";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import { ButtonConfig } from "../Models/Buttons";

const namespace: string = "config";
@Component({
	components: {
		ParticaError,
		ParticaCard,
		ParticaColumnContainer,
		ParticaView,
		//AccountStreamOwnerPayments,
		ParticaRightDrawer,
		//AccountStreamTailoringPayments,
		ParticaList2Line
	}
})
export default class Home extends ParticaAccountBase {
	@Prop() private id: number; // accountid
	private contentStreamService: IContentStreamPaymentService;
	private ownerPayments: OwnerPaymentDTO[] = [];
	private drawer: boolean = false;
	private tailordrawer: boolean = false;
	private selected: OwnerPaymentDTO = new OwnerPaymentDTO();
	private selectedTailoring: TailoringPaymentDTO = new TailoringPaymentDTO();
	private tailoringPayments: TailoringPaymentDTO[] = new Array<TailoringPaymentDTO>();
	private listdata: ParticaListContent = new ParticaListContent();
	private userService: IUserService;
	private buttons: ButtonConfig[] = [];


	private getArticles() {
		const group = ArrayUtils.groupByString(this.selected.articles as OwnerPaymentArticleDTO[],
			(a: OwnerPaymentArticleDTO) => a.article as string);
		return group;
	}
	private getIssues() {
		const group = ArrayUtils.groupByString(this.selectedTailoring.issues as TailoringPaymentIssueDTO[],
			(a: TailoringPaymentIssueDTO) => `${a.stream} : ${a.issue} ($${a.amount})` as string);
		return group;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.LEFT_MOUSE_CLICK: {
					this.drawer = true;
					this.selected = event.item as OwnerPaymentDTO;
					break;
				}
				case eParticaAction.CONTENT_STREAM_TAILORING_SELECT: {
					this.tailordrawer = true;
					this.selectedTailoring = event.item as TailoringPaymentDTO;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, `Unable to process event ${event.action}`);
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		this.contentStreamService = this.particaServices.getContentStreampaymentService();
		this.userService = this.particaServices.getUserService();
		await this.init();
	}

	@Watch("stateconfig.accountid")
	private async changeid() {
		this.navigate("home", { id: this.stateconfig.accountid });
	}

	private async init() {
		try {
			this.LoadingStart();
			this.listdata.lines = [];
			if (this.id === 0) {
				return;
			}
			await this.getAccountNav(this.id);
			if (this.stateconfig.admin === true) {
			//	this.ownerPayments = await this.contentStreamService.GetAccountPayments(this.id);
			//	this.tailoringPayments = await this.contentStreamService.GetTailoringPayments(this.id);
			}
			const users: UserLoginDetails[] = await this.userService.getUsers(this.id);
			users.forEach(user => {
				const line: ParticaListLineContent = { subtitle: user.provider, title: user.email, image: "" } as ParticaListLineContent;
				this.listdata.lines.push(line);
			});
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured initialising the page ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}

}
